namespace $.$$ {

	export class $shm_hitalama_quick extends $.$shm_hitalama_quick {

		@ $mol_mem
		ids_ordered( next?: string[] ) {
			return next ?? this.ids()
		}

		@ $mol_mem
		ids( next?: string[] ) {
			return next ?? []
		}

		@ $mol_mem
		buttons() {
			return this.ids().map( id => this.Drag( id ) )
		}
		key( id: any ): string {
			const cur_pos = this.ids_ordered().indexOf( id )+1
			return cur_pos.toString()
		}
		item_title( id: any ): string {
			return this.item( id ).title()
		}
		label( id: any ): string {
			return [...this.item_title( id )][0] ?? ''
		}

		@ $mol_mem
		some_dragged(): boolean {
			return this.ids().some( id => this.dragged(id) )
		}
		@ $mol_mem
		remove_area_visible(): readonly ( any )[] {
			if( !this.some_dragged() ) return []
			return $mol_error_fence( ()=> {
				this.$.$mol_wait_timeout(300)
				return super.remove_area_visible()
			}, ()=>[], ()=>[] )
		}

		on_drag_start( id: any, next: PointerEvent ) {
			this.drag_start_event( id, next )
			this.drag_end_event( id, null )
		}

		on_drag_end( id: any, next?: PointerEvent ) {
			this.drag_end_event( id, next ?? null )
			if( this.remove_area_active() ) {
				this.item_remove( id )
			}
		}

		@ $mol_mem_key
		drag_pan( id: any ): boolean {
			const start_event = this.drag_start_event( id )
			const end_event = this.drag_end_event( id )
			if( !start_event || !end_event ) return false
			return $shm_hitalama_is_panning( start_event, end_event )
		}

		@ $mol_action
		item_remove( id: string ) {
			this.ids( this.ids().filter( item => item != id ) )
			this.ids_ordered( this.ids_ordered().filter( item => item != id ) )
		}

		@ $mol_mem_key
		x( id: any, next?: number ): number {
			if( !this.dragged(id) ) return this.relative_x(id)
			if( next === undefined ) return this.relative_x(id)

			if( next > this.width() + 100 ) {
				this.ids_ordered( this.ids_ordered().filter( i => i != id ) )
				this.remove_area_active( true )
				return next
			}
			this.remove_area_active( false )

			const lines = this.lines()
			let next_pos = lines.length > 0 ? -1 : 0
			let last_dif = Infinity
			for (const line of lines) {
				const next_dif = Math.abs(line.start - next)
				if( next_dif < last_dif ) {
					last_dif = next_dif
					next_pos++
				}
				else break
			}
			const cur_pos = this.ids_ordered().indexOf( id )
			if( cur_pos != next_pos ) {
				const next_ids = [...this.ids_ordered()]
				if( cur_pos != -1 ) {
					next_ids.splice( cur_pos, 1 )
				}
				next_ids.splice( next_pos, 0, id )
				this.ids_ordered( next_ids )
			}

			return next
		}

		lines() {
			const ids = this.ids_ordered()
			const lines: { start: number, center: number }[] = []
			let x = 0

			for (let i = 0; i < ids.length; i++) {
				const w = this.Drag(ids[i]).view_rect()?.width!
				lines.push( { start: x, center: x + w/2 } )
				x += w
			}

			return lines
		}

		@ $mol_mem
		full_width_px() {
			return this.width()+'px'
		}

		@ $mol_mem
		width() {
			const x = this.ids_ordered().reduce<number>( (acc, id)=> {
				const width = this.Drag(id).view_rect()?.width!
				return acc + width
			}, 0 )
			return x
		}

		@ $mol_mem_key
		relative_x( id: any ) {
			const pos = this.ids_ordered().indexOf( id )
			return this.lines()?.[pos]?.start ?? 0
		}

		pointerenter( id: any, next?: any ) {
			this.hovered_id(id)
		}
		pointerleave( id: any, next?: any ) {
			this.hovered_id('')
		}

		@ $mol_mem
		hovered_title_visible(): readonly ( any )[] {
			if( this.ids().length == 0 ) return []
			return this.hovered_id() ? super.hovered_title_visible() : []
		}
		@ $mol_mem
		hovered_title(): string {
			const id = this.hovered_id()
			return this.item_title(id)
		}

		document() {
			return this.$.$mol_dom_context.document
		}
		
	}

}
